import styled from "@emotion/styled";
import { RectSkeleton } from "../skeleton";
import { BaseCardStyles } from "./base";

export const LoadingCard = styled(RectSkeleton)`
  ${BaseCardStyles}
  box-shadow: none;
`;
